import React from "react"
import { ThemeProvider, Global, css } from "@emotion/react"
import { theme } from "../styles/theme"

export const RootWrapper = ({ element }: { element: React.ReactNode }) => {
  return (
    <ThemeProvider theme={theme}>
      <Global
        styles={css`
          body {
            margin: 0;
            padding: 0;
            font-family: ${theme.typography.fontFamily};
            background-color: ${theme.colors.background};
            color: ${theme.colors.text};
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
          * {
            box-sizing: border-box;
          }
          a {
            text-decoration: none;
            color: inherit;
          }
          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            color: ${theme.colors.primary};
            margin-top: 0;
          }
        `}
      />
      {element}
    </ThemeProvider>
  )
}
